import { z } from "zod";

export const RechargeOAuthLoginQueryParamSchema = z.object({
  myshopify_domain: z.string(),
  code: z.string(),
});
export type RechargeOAuthLoginQueryParamType = z.infer<
  typeof RechargeOAuthLoginQueryParamSchema
>;
